import { TextField as BaseTextField } from '@kvdbil/components';
import { TextFieldProps as BaseTextFieldProps } from '@kvdbil/components/types/components/Textfield';
import React, { RefObject } from 'react';
import { Controller, FieldValues } from 'react-hook-form';
import { formatMoneyWithoutCurrency } from '~/helpers/currency';
import { useTranslation } from '~/Locale';
import { TextFieldProps } from './TextFieldWithControl';

const Input = React.forwardRef((props: BaseTextFieldProps, ref) => (
  <BaseTextField {...props} forwardRef={ref as RefObject<HTMLInputElement>} />
));

const PriceTextFieldWithControl = <FormState extends FieldValues>(
  props: TextFieldProps<FormState>
) => {
  const { t } = useTranslation();

  return (
    <Controller<FormState>
      {...props}
      render={({ field, fieldState }) => {
        const formattedValue = field.value
          ? formatMoneyWithoutCurrency(field.value)
          : '';

        return (
          <Input
            {...props}
            {...field}
            onChange={e => {
              const rawValue = e.target.value;
              const strippedValue = rawValue.split(' ').join('');
              field.onChange(strippedValue);
            }}
            label={props.label ?? t('Enter price')}
            value={formattedValue}
            errors={[fieldState.error?.message ?? '']}
            hasError={Boolean(fieldState.error)}
          />
        );
      }}
    />
  );
};

export default PriceTextFieldWithControl;
